<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Deleted Parcels</h3>
                    </div>
                    <div class="col-12 col-xl-4">

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row mb-3">
                     <div class="col-sm-4 col-md-3 col-6 stretch-card col-grid"></div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    <div class="col-sm-4 col-md-3 col-6 stretch-card col-grid">
                        <div class="d-flex w-100">
                                            <input type="text" v-model="this.filter_branch"
                                                style="width: 85px !important;" class="form-control"
                                                placeholder="Filter">
                                            <select v-model="branch_from" class="form-select form-control">
                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>

                                        </div>
                    </div>
                  
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterParcel" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                    
                </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                                             <div id="data-head" class="text-center">
                   <h4>{{ this.heading }}</h4>
                </div>

                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th> Package name</th>
                            <th>Package Type</th>
                            <th> Price </th>
                            <th> From Destn </th>
                            <th> Final Destn </th>
                           <th> Sent By </th>
                            <th> Removed By </th>
                            <th> Reason to remove</th>
                            <th> Created Date </th>
                            <th> Received Date </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                               <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                               <td class="text-capitalize">{{parcel.name}}</td>
                            <td><label class="badge badge-info">{{parcel.package_tag}}</label></td>
                            <td class="text-capitalize"> <PriceFormat :Price="parcel.price"/> </td>
                            <td><label class="badge badge-primary">{{parcel.bfname}}</label></td>
                            <td> <label class="badge badge-success">{{parcel.btname}}</label></td>
                            <td> {{parcel.fulname}}</td>
                            <td> {{parcel.remove_staff}}</td>
                            <td> {{parcel.remove_description}}</td>
                                <td><DateFormat :Date_="parcel.created_at"/></td>
                               <td><DateFormat :Date_="parcel.closed_at"/></td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            heading:"Deleted Parcel For All Destinations",
            branches: [],
            og_branches: [],
            branch_from:0,
            branch_to:0,
            staff_id:0,
            fdate:"",
            tdate:"",
            filter_branch: "",
            parcels:[],
            og_parcels:[],
             staffs:[],
            parcel: {},
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async filterParcel(){

             this.loading = true

          var branch = this.branch_from
          var fdate = this.fdate
          var tdate = this.tdate

          var response = await axios
              .post(this.$store.state.api_url + "/filter-removed-parcels", {branch, fdate, tdate})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

                var fromb = this.getBranchName(branch, this.branches)
               
                this.heading = "Deleted Parcels "+fromb+" ("+fdate+" To "+tdate+")"
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        async getAllBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/all-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = [ { id: 0, name: "From All Destinations" },...response.data.branches];
                this.og_branches = [ { id: 0, name: "From All Destinations" },...response.data.branches];

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async getParcels() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/removed-parcels")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
this.loading = false
                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

               /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },
        getBranchName(id, branches) {

        const branch = branches.find(item => item.id == id);

        return branch ? branch.name : "";

    },
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term))
                )

            })

        }
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getAllBranch()
        this.getParcels()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
